import React from "react";
import "./ClaimManagement.css"; // Optional: For custom styles
import GA from "../functions/GA";
import selectCorrectUrls from "../../selectCorrectUrls";
import layout from "../../assets/img/car-woman.svg";

const ClaimManagement = ({ responsiveStatus }) => {
  return (
    // <div className="py-1" style={{ backgroundColor: "#F1F7FD", height: "350px" }}>
    <div
      className="py-1"
      style={{
        // ...(responsiveStatus === "isDesktop"
        //   ? styles.container
        //   : responsiveStatus === "isTablet" ||
        //     responsiveStatus === "isTabletLandscape"
        //   ? styles.container
        //   : styles.container1),
        maxWidth: "1350px",
        margin:
          responsiveStatus === "isDesktop"
            ? "3em auto"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? "3em auto"
            : "0 auto",
      }}
    >
      <div
        className={`${
          responsiveStatus === "isDesktop"
            ? "row align-items-center w-100"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? "row align-items-center w-100"
            : "row-m align-items-center w-100"
        }`}
      >
        {/* Image Section */}
        {responsiveStatus !== "isMobile" &&
          responsiveStatus !== "isSmallMobile" && (
            <div className="col-md-6 text-center col-12">
              {responsiveStatus !== "isMobile" ||
              responsiveStatus !== "isSmallMobile" ? (
                <img
                  src={require("../../assets/img/car-woman.png")}
                  alt="Car and Woman"
                  className="img-fluid"
                  style={{ maxHeight: "400px" }}
                />
              ) : null}
            </div>
          )}

        {/* Content Section */}
        <div
          className="col-12 col-md-6 text-left text-md-start mt-4 mt-md-0 claim-management"
          style={{
            display: "block",
            justifyContent: "center",
            alignItems: "center",
            paddingLeft: "6em",
          }}
        >
          <p
            className="fw-bold mb-3"
            style={{
              fontSize: "20px",
              whiteSpace: "nowrap",
            }}
          >
            <span
              style={{
                borderBottom: "2px solid #0E72D6",
                paddingBottom: "13px",
              }}
            >
              Claim Man
            </span>
            agement
          </p>
          <p
            className={`${
              responsiveStatus === "isDesktop"
                ? "mb-4 mt-4 p-heading"
                : responsiveStatus === "isTablet" ||
                  responsiveStatus === "isTabletLandscape"
                ? "mb-4 mt-4 p-heading"
                : "mb-4 mt-4 p-headingM"
            }`}
          >
            Effortless Claims, Real-Time Status, and Easy Payments Navigate
            Through Options Tailored to Your Needs
          </p>
          <a
            className="btn btn-primary-buttons-claim mb-3"
            aria-label="Click to File a claim"
            onClick={() => {
              GA(
                "Claims_Home_menu_bar",
                "User clicked on claims button Home page banner menu"
              );
            }}
            // href="https://www.mypolicy.net/insurednew"
            target=""
            rel="noreferrer"
            style={{
              color: "white",
              textDecoration: "none",
              width:
                responsiveStatus === "isDesktop"
                  ? "fit-content"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "fit-content"
                  : "auto",
              margin: "0 auto",
              fontWeight: 500,
            }}
            href={`${
              selectCorrectUrls().insuredPortal
            }/insurednew/insured/claimuser/index`}
          >
            {responsiveStatus === "isDesktop"
              ? "Claims"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "Claims"
              : "Portal Login"}
          </a>
          <div className="d-flex justify-content-center justify-content-md-start gap-4">
            <a
              onClick={() => {
                GA(
                  "Claims_Home_menu_bar",
                  "User clicked on File a claim Home page banner menu"
                );
              }}
              target=""
              rel="noreferrer"
              href={`https://account-management-claims-uaic-gwcpprod-prod.delta4-andromeda.guidewire.net/account-management-claims/tpp-claims`}
              className={`${
                responsiveStatus === "isDesktop"
                  ? "text-primary"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "text-primary"
                  : "text-primary"
              }`}
            >
              File a Claim
            </a>
            <a
              onClick={() => {
                GA(
                  "Claims_Home_menu_bar",
                  "User clicked on check claim status on banner menu"
                );
              }}
              target=""
              rel="noreferrer"
              href={`https://www.uaig.net/uaichome/#/uaichome/claims`}
              className={`${
                responsiveStatus === "isDesktop"
                  ? "text-primary"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "text-primary"
                  : "text-primary"
              }`}
            >
              Claim Status
            </a>
            <a
              onClick={() => {
                GA(
                  "Claims_Home_menu_bar",
                  "User clicked on subro payment on banner menu"
                );
              }}
              target=""
              rel="noreferrer"
              href={`https://quote7.uaig.net/subro/#/subro`}
              className={`${
                responsiveStatus === "isDesktop"
                  ? "text-primary"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "text-primary"
                  : "text-primary"
              }`}
            >
              Make a Subro Payment
            </a>
          </div>
        </div>
        {responsiveStatus === "isMobile" ||
          (responsiveStatus === "isSmallMobile" && (
            <div className="col-md-6 text-center col-12">
              {responsiveStatus === "isMobile" ||
              responsiveStatus === "isSmallMobile" ? (
                <img
                  src={require("../../assets/img/car-woman.png")}
                  alt="Car and Woman"
                  className="img-fluid"
                  style={{ maxHeight: "400px" }}
                />
              ) : null}
            </div>
          ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
  },
};

export default ClaimManagement;
